const GlobalContextActionType = {
  SET_CONTEXT: 'SET_CONTEXT',
  SET_LOGIN_DETAILS: 'SET_LOGIN_DETAILS',
  SET_TOAST_CONFIG: 'SET_TOAST_CONFIG',
  SET_LOADER_CONFIG: 'SET_LOADER_CONFIG',
  SET_USER_DETAILS: 'SET_USER_DETAILS',
};

export default GlobalContextActionType;
